module.exports = __webpack_public_path__ + "static/leg_crossing_hardware_4framesV2-33ed210c31b1295ee61124c7f7fcb7c7.png";